import { Box,  Image, Stack } from '@chakra-ui/react';


export default function MyImage({ imageUrl, color }) {
  return (
  <Stack position="relative">
    <Box
        w={{base: '250px', md: '350px', lg: '350px', xl: '450px'}}
        h={{base: '250px', md: '350px', lg: '350px', xl: '450px'}}
        alignItems="center"
        justifyContent="center"
        // clipPath="polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)"
        zIndex='1'    
  >
    <Image 
        w="100%" h="100%"
        zIndex={2}
        src={imageUrl} 
        bgPosition="center" 
        bgSize="cover" 
        borderRadius="inherit"
         />
  </Box>
  {/* <Box
   w={{base: '250px', md: '350px', lg: '350px', xl: '450px'}}
   h={{base: '250px', md: '350px', lg: '350px', xl: '450px'}}
    position="absolute"
    top="5"
    left="3"
    // borderWidth="5px"
    // borderColor={'white'}
    justifyContent="center"
    clipPath="polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)"
    // bg={'transparent'}
    bg={color}
    zIndex='0'
    style={{  pointerEvents: 'none'}}
  /> */}
</Stack>
  );
}
